function LeftChevron({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '8'} height=${(dimensions * 5) / 3 || '12'} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.70687 1.41L6.29688 0L0.296875 6L6.29688 12L7.70687 10.59L3.12687 6L7.70687 1.41Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default LeftChevron;
